import { render, staticRenderFns } from "./IconMenu.vue?vue&type=template&id=03d619cc&scoped=true&"
import script from "./IconMenu.vue?vue&type=script&lang=js&"
export * from "./IconMenu.vue?vue&type=script&lang=js&"
import style0 from "./IconMenu.vue?vue&type=style&index=0&id=03d619cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d619cc",
  null
  
)

export default component.exports